module.exports = __webpack_public_path__ + "img/escola_creative.bc036574.png";